// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
   version: '3.17.0',
   production: false,
   notification: true,
   allowUnsafePixOnboardingRetry: true,
   auth0Config: {
      //clientID: 'yFhU6PFbYRG9272CRoJjklBc0YowXSlt',
      //domain: 'kcmsbrasil.auth0.com',
      clientID: 'r2BNKzu3U1uRLKOeGGOZ2eCh7WfEQX0c',
      domain: 'login-dev.kcms.com.br',
      responseType: 'token id_token',
      audience: 'https://audience-dev.kcms.com.br',
      //redirectUri: 'https://app-platform-main-web-dev-use2.azurewebsites.net',
      redirectUri: 'https://app-dev.kcms.com.br',
      // redirectUri: 'http://localhost:4200',
      scope: 'openid profile email',
   },
   apiBaseUrl: 'https://app-platform-main-api-dev-use2.azurewebsites.net/',
   apiPrefix: 'api/v1',
   odataPrefix: 'odata/v1',
   aiServiceBaseUrl: 'https://app-ai-main-api-dev-use2.azurewebsites.net/',
   menuServiceBaseUrl: 'https://menu-dev.kcms.app/',
   menuServiceWaiterBaseUrl: 'https://garcom-dev.kcms.app/',
   menuServiceCheckerBaseUrl: 'https://checker-dev.kcms.app/',
   kdsPanelBaseUrl: 'https://app-orderpanel-web-dev-use2.azurewebsites.net/',
   loyaltyProgramBaseUrl: 'https://clube-dev.kcms.com.br/',
   deliveryServiceBaseUrl: 'https://pede-dev.kcms.app/',
   orderCenterBaseUrl: 'https://app-ordercenter-api-dev-use2.azurewebsites.net/',
   platformHubUrl: 'https://app-platform-main-hub-dev-use2.azurewebsites.net/Platform',
   // erpHubUrl: 'https://main-hub-dev.azurewebsites.net/Erp',
   orderCenterHubUrl: 'https://app-platform-main-hub-dev-use2.azurewebsites.net/OrderCenter',
   // permissionsObjectName: 'https://soluserp.kcms.com.br/claims/permissions',
   // groupsObjectName: 'https://soluserp.kcms.com.br/claims/groups',
   // rolesObjectName: 'https://soluserp.kcms.com.br/claims/roles',
   cryptoKey: 'NcVcqQIHLdXsPpUW',
   cryptoIV: 'NcVcqQIHLdXsPpUW',
   intercomAppId: 'ew8gy634',
   wootricAccountToken: 'NPS-5c84d1dd',
   orderCenterRing: 'old_telephone.mp3',
   cloudPaymentUrl: 'https://stone-payment-api-dev.azurewebsites.net/',
   financialApiUrl: 'https://app-platform-financial-api-dev-use2.azurewebsites.net/',
   calculadoraReformaApiUrl:
      'https://app-kcms-calc-rtc-prd-use-b8a8hufuffc3c2cw.eastus-01.azurewebsites.net/api',
   deliveryServiceApiUrl: 'https://app-delivery-service-api-dev-use2.azurewebsites.net/',
   googleApiKey: 'AIzaSyAifx7AaE1TQH260DuEXTqu-_Fm0u3vT2g',
   easyChoppApiUrl: 'https://easychopp-api-prod.azurewebsites.net/',
   ifoodDeliveryTrackingApiUrl: 'https://meupedido.ifood.com.br/',
   webVersion10Url: 'https://app-dev.kcms.com.br/',
   adsense: {
      adClient: 'ca-pub-0402701089458425',
      slot: 1436596987,
      adFormat: 'horizontal',
      fullWidthResponsive: true,
      debug: true,
   },
   appInsights: {
      enabled: false,
      instrumentationKey: '0b7fa2df-fc42-4158-a993-909c6a3a7542',
   },
   trialWhatsAppPhoneNumber: '551534120001',
   onboardingWhatsAppPhoneNumber: '551534120001',
   mixpanel: {
      enabled: false,
      debug: true,
      key: '8cb988c00a2380af716eaf614cbe5895',
   },
};
